import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
} from '@angular/core';

import { MegamenuSectionComponent } from '../megamenu-section/megamenu-section.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[appMegamenuTriggerFor]',
  imports: [],
  templateUrl: './megamenu-trigger.component.html',
  styleUrls: ['./megamenu-trigger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MegamenuTriggerComponent {
  private readonly nativeElement: HTMLElement = inject(ElementRef).nativeElement;

  @Input('appMegamenuTriggerFor')
  section!: MegamenuSectionComponent;

  focus(): void {
    this.nativeElement.focus();
  }
}
